// @flow
import { NotificationMessage, SidebarSection, Text } from 'bench-internal-theme';
import React from 'react';
import { Query } from '@apollo/client/react/components';

import JournalEntryCategorizationClientRule from './JournalEntryCategorizationClientRule';
import { GET_CLIENT_RULE } from './queries';

type JournalEntryCategorizationContainerProps = {
  categorizerMethod: string,
  journalEntryId: string,
  clientRuleId: string,
  showClientRuleEditForm: () => void,
};

const JournalEntryCategorizationContainer = ({
  categorizerMethod,
  journalEntryId,
  showClientRuleEditForm,
  clientRuleId,
}: JournalEntryCategorizationContainerProps) => {
  if (categorizerMethod === 'CLIENT_RULE' && clientRuleId) {
    return (
      <Query query={GET_CLIENT_RULE} variables={{ id: clientRuleId }}>
        {(getClientRule: any) => {
          if (getClientRule.loading) {
            return null;
          }
          if (getClientRule.error) {
            return (
              <NotificationMessage styleType="error">
                There was a problem loading the client rule. The error was “
                {getClientRule.error.message}”
              </NotificationMessage>
            );
          }
          return (
            <JournalEntryCategorizationClientRule
              clientRule={getClientRule.data.clientRule}
              journalEntryId={journalEntryId}
              showClientRuleEditForm={showClientRuleEditForm}
            />
          );
        }}
      </Query>
    );
  }

  if (categorizerMethod === 'CLIENT_RULE' && !clientRuleId) {
    return (
      <SidebarSection>
        <Text>Categorization Method: CLIENT RULE</Text>
      </SidebarSection>
    );
  }

  if (categorizerMethod === 'GLOBAL_RULE') {
    return (
      <SidebarSection>
        <Text>Categorization Method: GLOBAL RULE</Text>
      </SidebarSection>
    );
  }
  if (categorizerMethod === 'ML') {
    return (
      <SidebarSection>
        <Text>Categorization Method: ML PREDICTION</Text>
      </SidebarSection>
    );
  }
  return null;
};

export default JournalEntryCategorizationContainer;
